import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import footerImage from '../Images/footer.png';

const styles = (theme) => ({
  footerContainer: {
    padding: '0 !important',
    marginTop: theme.spacing(10),
    backgroundColor: '#201F1F',
  },
  footerBar: {
    backgroundColor: '#201F1F',
    padding: theme.spacing(2),
  },
  textFooterTerms: {
    color: '#7C7A7A',
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
  },
  textFooter: {
    color: '#7C7A7A',
    fontWeight: 'bold',
  },
  trademarkText: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

function WithFooter({ classes }) {
  return (
    <Translation>
      {(t) => (
        <Grid className={classes.footerContainer} item xs={12}>
          <img src={footerImage} alt="footer" width="100%" />
          <Grid
            className={classes.footerBar}
            container
            direction="row"
            justifyContent="space-around"
          >
            <Grid item xs={4}>
              <Grid container direction="row">
                <Link to="/toc">
                  <Typography
                    className={classes.textFooterTerms}
                    variant="subtitle1"
                  >
                    {t('termsAndConditions')}
                  </Typography>
                </Link>
                <Link to="/privacy">
                  <Typography
                    className={classes.textFooter}
                    variant="subtitle1"
                  >
                    {t('privacyPolicy')}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
            <Grid className={classes.trademarkText} item xs={4}>
              <Typography className={classes.textFooter} variant="subtitle1">
                {t('ministry', { year: new Date().getFullYear() })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Translation>
  );
}

export default withStyles(styles)(WithFooter);



// WEBPACK FOOTER //
// ./src/view/scenes/components/Footer.js